"use client";

import { useEffect, useRef, useState } from "react";

const VARIANT_COLORS: Record<"light" | "dark", string> = {
  light: "#EDEADE",
  dark: "#5A7A38",
};

export function TextCover({
  children,
  variant = "light",
  delay = 0,
}: {
  children: React.ReactNode;
  variant?: "light" | "dark";
  delay?: number;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const t = setTimeout(() => setRevealed(true), delay);
          return () => clearTimeout(t);
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [delay]);

  return (
    <div ref={ref} className="relative overflow-hidden">
      {children}
      <div
        aria-hidden="true"
        className="absolute inset-0"
        style={{
          backgroundColor: VARIANT_COLORS[variant],
          transform: revealed ? "translateX(101%)" : "translateX(0)",
          transition: "transform 450ms ease-out",
        }}
      />
    </div>
  );
}
